<div class="position-reletivediv register-panel-root">
  <div class="popup-inner-space border-bottom-grey">
    <div class="betweenheader text-dark"> Meter Configuration - {{this.selectedmetername}} </div>
    <div class="text-right flow-right"><img src="../../../assets/images/close_icon.svg" alt="..."
        class="img-fluid closeicon2 cursor-pointer" (click)="Close()"></div>
  </div>

  <div class="register-panel-layout">
    <div class="popup-inner-space" style="margin-top: 10px!important;">
      <div class="errmsg error-register" *ngIf="errorMsg">{{errorMsg}}</div>
      <div class="sucessmsg  error-register" *ngIf="successMsg">{{successMsg}}</div>
    </div>

    <form [formGroup]="virtualregisterpanelForm" class="width100 register-panel-form" id="virtualregisterpanelForm">
      <div class="register-panel-add-row">
        <button class="btncommon width-fix67" type="button" (click)="OnAddRegisterData()">Add</button>
      </div>

      <div class="table-body-main mx-3 register-table-scroll-wrapper register-panel-table-area">
        <table class="table-main-register table register-panel-table register-panel-virtual" *ngIf="flag==false" id="tableregisterpanel">
          <colgroup>
            <col style="width:9%"><col style="width:5%"><col style="width:9%"><col style="width:5%">
            <col style="width:5%"><col style="width:5%"><col style="width:9%"><col style="width:7%">
            <col style="width:6%"><col style="width:7%"><col style="width:8%"><col style="width:5%">
            <col style="width:5%"><col style="width:6%"><col style="width:6%"><col style="width:5%">
          </colgroup>
          <thead class="thead-data" id="theadregisterpanel">
            <tr>
              <th class="font_14 color_black" id="thregisterRegName">Register name</th>
              <th class="font_14 color_black" id="thregisterRegNo">Register no</th>
              <th class="font_14 color_black" id="thregisterUnit">Unit</th>
              <th class="font_14 color_black" id="thregisterZeroScale">Zero scale</th>
              <th class="font_14 color_black" id="thregisterFullScale">Full scale</th>
              <th class="font_14 color_black" id="thregisterLocation">Location</th>
              <th class="font_14 color_black" id="thregisterDataType">Data type</th>
              <th class="font_14 color_black" id="thregisterfunctionCode">Function code</th>
              <th class="font_14 color_black" id="thregisterDecimalPoint">Decimal point</th>
              <th class="font_14 color_black" id="thregisterDecimalPointfront">Decimal point (front)</th>
              <th class="font_14 color_black" id="thregisterAction">Read/write action</th>
              <th class="font_14 color_black register-checkbox-head" id="thregisterIsDisplaygraph">Is display graph</th>
              <th class="font_14 color_black register-checkbox-head" id="thregisterIsTotalizer">Is totalizer</th>
              <th class="font_14 color_black" id="thregisterHighValue">High value</th>
              <th class="font_14 color_black" id="thregisterLowValue">Low value</th>
              <th class="font_14 color_black text-center" id="thregisterActionCol">Action</th>
            </tr>
          </thead>
          <tbody formArrayName="listRegisterdata" id="tableregisterlistRegisterdata">
            <ng-container
              *ngFor="let maxb of virtualregisterpanelForm['controls'].listRegisterdata['controls'];let i = index"
              formGroupName="{{i}}">
              <tr id="{{ 'trregisterlistRegisterdata' + i }}">
                <td id="{{ 'tdregisterlistRegisterName' + i }}" class="width-fix-table width12"
                  [ngClass]="{'errorborder' : virtualregisterpanelForm['controls'].listRegisterdata['controls'][i]['controls'].RegisterName.status == 'INVALID' && isSaveClick}">
                  <input class="focus-input
                       fxg-field__input-text fxg-field__input--required input-space
                       sessioncamexclude" name="rname" id="{{ 'rname' + i }}" formControlName="RegisterName" #rname
                    (focus)="rname.focus()" />
                  <p class="error_msg" *ngIf="ListdisplayMessage.RegisterName" id="{{ 'rname' + i }}">
                    {{ListdisplayMessage.RegisterName}}
                  </p>
                </td>
                <td class="width-fix-table position-reletivediv width10"
                  [ngClass]="{'errorborder' : virtualregisterpanelForm['controls'].listRegisterdata['controls'][i]['controls'].RegisterNO.status == 'INVALID' && isSaveClick}">
                  <input class="focus-input input-space
                       fxg-field__input-text fxg-field__input--required
                       sessioncamexclude" name="rnumber" id="rnumber" formControlName="RegisterNO" OnlyNumber #rno
                    (focus)="rno.focus()" />
                </td>
                <td class="width-fix-table position-reletivediv register-unit-cell"
                  [ngClass]="{'errorborder' : virtualregisterpanelForm['controls'].listRegisterdata['controls'][i]['controls'].Unit.status == 'INVALID' && isSaveClick}">
                  <input class="focus-input register-unit-input input-space
                       fxg-field__input-text fxg-field__input--required sessioncamexclude"
                    name="unit" id="{{ 'unit' + i }}" formControlName="Unit" maxlength="50" #unitInput
                    [matAutocomplete]="unitAuto" placeholder="Select unit"
                    [readonly]="virtualregisterpanelForm['controls'].listRegisterdata['controls'][i]['controls'].IsFromParameterConfig.value == 'Y'"
                    (focus)="unitInput.focus()" />
                  <mat-autocomplete #unitAuto="matAutocomplete" panelClass="register-panel-autocomplete-panel"
                    (optionSelected)="OnChange('unit')">
                    <mat-option *ngFor="let lstunit of UnitList" [value]="lstunit.CodeDisplayName">
                      {{ lstunit.CodeDisplayName }}
                    </mat-option>
                  </mat-autocomplete>
                </td>
                <td class="width-fix-table position-reletivediv width7"
                  [ngClass]="{'errorborder' : virtualregisterpanelForm['controls'].listRegisterdata['controls'][i]['controls'].ZeroScale.status == 'INVALID' && isSaveClick}">
                  <input class="focus-input input-space
                                       fxg-field__input-text fxg-field__input--required
                                       sessioncamexclude" name="ZeroScale" id="ZeroScale" formControlName="ZeroScale"
                    type="number" maxlength="20" #ZeroScale (focus)="ZeroScale.focus()" />
                </td>
                <td class="width-fix-table position-reletivediv width7"
                  [ngClass]="{'errorborder' : virtualregisterpanelForm['controls'].listRegisterdata['controls'][i]['controls'].FullScale.status == 'INVALID' && isSaveClick}">
                  <input class="focus-input input-space
                                                       fxg-field__input-text fxg-field__input--required
                                                       sessioncamexclude" name="FullScale" id="FullScale" type="number"
                    formControlName="FullScale" maxlength="20" #FullScale (focus)="FullScale.focus()" />
                </td>
                <td class="width-fix-table position-reletivediv width7"
                  [ngClass]="{'errorborder' : virtualregisterpanelForm['controls'].listRegisterdata['controls'][i]['controls'].Location.status == 'INVALID' && isSaveClick}">
                  <input class="focus-input input-space
                                                                         fxg-field__input-text fxg-field__input--required
                                                                         sessioncamexclude" name="Location"
                    id="Location" type="number" formControlName="Location" maxlength="20" #Location
                    (focus)="Location.focus()" />
                </td>
                <td class="width12"
                  [ngClass]="{'errorborder' : virtualregisterpanelForm['controls'].listRegisterdata['controls'][i]['controls'].DataType.status == 'INVALID' && isSaveClick}">
                  <mat-select class="mat-space focus-input" name="datatype" id="datatype" formControlName="DataType"
                    required="" aria-required="true" #dataType (focus)="dataType.focus()"
                    (selectionChange)="OnChange('dataType')">
                    <mat-option value="">(Select DataType)</mat-option>
                    <mat-option MatFormFieldControl="datatype" *ngFor="let lstdatatype of DatatypeList"
                      [value]="lstdatatype.CodeDescription">
                      {{lstdatatype.CodeDisplayName}}
                    </mat-option>
                  </mat-select>
                </td>
                <td class="width8"
                  [ngClass]="{'errorborder' : virtualregisterpanelForm['controls'].listRegisterdata['controls'][i]['controls'].FunctionCode.status == 'INVALID' && isSaveClick}">
                  <mat-select class="focus-input" name="fcode" id="fcode" formControlName="FunctionCode" required=""
                    aria-required="true" class="mat-space focus-input" #fcode (focus)="fcode.focus()"
                    (selectionChange)="OnChange('FunctionCode')">
                    <mat-option value="">(Select Function Code)</mat-option>
                    <mat-option MatFormFieldControl="fcode" *ngFor="let lstfunctioncode of FunctionCodeList"
                      [value]="lstfunctioncode.CodeValue">
                      {{lstfunctioncode.CodeDisplayName}}
                    </mat-option>
                  </mat-select>
                </td>
                <td class="width8"
                  [ngClass]="{'errorborder' : virtualregisterpanelForm['controls'].listRegisterdata['controls'][i]['controls'].DecimalPoint.status == 'INVALID' && isSaveClick}">
                  <mat-select class="mat-space focus-input" name="dpoint" id="dpoint" formControlName="DecimalPoint"
                    required="" aria-required="true" #Dpoint (focus)="Dpoint.focus()"
                    (selectionChange)="OnChange('DecimalPoint')">
                    <mat-option value="">(Select Decimal Point)</mat-option>
                    <mat-option MatFormFieldControl="dpoint" *ngFor="let lstdecimalpoint of DecimalPointList"
                      [value]="lstdecimalpoint.CodeValue">
                      {{lstdecimalpoint.CodeDisplayName}}
                    </mat-option>
                  </mat-select>
                </td>
                <td class="width10"
                  [ngClass]="{'errorborder' : virtualregisterpanelForm['controls'].listRegisterdata['controls'][i]['controls'].DecimalPointForFront.status == 'INVALID' && isSaveClick}">
                  <mat-select class="mat-space focus-input" name="dpointfront" id="dpointfront"
                    formControlName="DecimalPointForFront" required="" aria-required="true" #DpointFront
                    (focus)="DpointFront.focus()" (selectionChange)="OnChange('DecimalPointForFront')">
                    <mat-option value="">(Select Decimal Point)</mat-option>
                    <mat-option MatFormFieldControl="dpointfront" *ngFor="let lstdecimalpoint of DecimalPointFrontList"
                      [value]="lstdecimalpoint.CodeValue">
                      {{lstdecimalpoint.CodeDisplayName}}
                    </mat-option>
                  </mat-select>
                </td>
                <td class="width10"
                  [ngClass]="{'errorborder' : virtualregisterpanelForm['controls'].listRegisterdata['controls'][i]['controls'].ReadWriteAction.status == 'INVALID' && isSaveClick}">
                  <mat-select class="mat-space focus-input" name="ReadWriteAction" id="ReadWriteAction"
                    formControlName="ReadWriteAction" required="" aria-required="true" #action (focus)="action.focus()"
                    (selectionChange)="OnChange('ReadWriteAction')">
                    <mat-option value="">(Select Action)</mat-option>
                    <mat-option MatFormFieldControl="ReadWriteAction" *ngFor="let lstactionpoint of ActionList"
                      [value]="lstactionpoint.CodeValue">
                      {{lstactionpoint.CodeDisplayName}}
                    </mat-option>
                  </mat-select>
                </td>
                <td class="register-checkbox-cell">
                  <input type="checkbox" class="register-row-checkbox cursor-pointer"
                    formControlName="IsDisplayGraph" #display (focus)="display.focus()" />
                </td>
                <td class="register-checkbox-cell">
                  <input type="checkbox" class="register-row-checkbox cursor-pointer"
                    formControlName="IsTotalizer" #isTotalizer (focus)="isTotalizer.focus()" />
                </td>
                <td class="width-fix-table position-reletivediv width5"
                  [ngClass]="{'errorborder' : virtualregisterpanelForm['controls'].listRegisterdata['controls'][i]['controls'].ReadWriteAction.status == 'INVALID' && isSaveClick}">
                  <input class="focus-input fxg-field__input-text fxg-field__input--required
                                     sessioncamexclude" name="rnumber1" id="rnumber1"
                    formControlName="HighThresoldValue" NumberWithDecimal maxlength="50"
                    [ngClass]="{'cursor-pointer-none' : IsreadOnly }" #threshold1 (focus)="threshold1.focus()" />
                </td>
                <td class="width-fix-table position-reletivediv width5"
                  [ngClass]="{'errorborder' : virtualregisterpanelForm['controls'].listRegisterdata['controls'][i]['controls'].ReadWriteAction.status == 'INVALID' && isSaveClick}">
                  <input class="focus-input fxg-field__input-text fxg-field__input--required
                                                       sessioncamexclude" name="rnumber1" id="rnumber1"
                    formControlName="LowThresoldValue" NumberWithDecimal maxlength="50"
                    [ngClass]="{'cursor-pointer-none' : IsreadOnly }" #threshold2 (focus)="threshold2.focus()" />
                </td>
                <td class="register-action-cell">
                  <i class="fa fa-pencil" style="font-size:15px;cursor: pointer;margin-right:8px;"
                    (click)="AddNewParameterConfig(maxb,i)"></i>
                  <img src="assets/images/delete.svg" alt="..." class="img-fluid closeicon2 cursor-pointer"
                    (click)="DeleteParamterData(maxb, i)" id="delete_icon">
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </form>

    <div class="d-flex justify-content-between px-3 register-panel-footer">
      <div class="d-flex"></div>
      <div class="d-flex register-panel-footer-actions">
        <button class="btncommon width-fix67" (click)="OnSubmit()">Save</button>
        <button class="btncommon-grey btn-border-add-company width-fix67" (click)="OnCancel()">Cancel</button>
      </div>
    </div>
  </div>
</div>
